module.exports = __webpack_public_path__ + "static/media/bathtub.753f3173.svg";